import { trackPromise } from 'react-promise-tracker';
import { fetchWithTimeout, getDomain,handleResponse, getPhishingAPIKey, doGet as authenticatedGet, doPost as authenticatedPost, doDelete as authenticatedDelete} from './BaseAPI.js';
import { simulationTemplates } from '../shared/simulationTemplates';


const servicesUrl = process.env.REACT_APP_CONSOLE_URL;
const goPhishingURL = process.env.REACT_APP_GO_PHISHING_URL;

function requestHeaders(moreHeaders) {
  const requestHeaders = new Headers();
  requestHeaders.append('Accept', 'application/json');
  requestHeaders.append('Content-Type', 'application/json');
  if(moreHeaders && moreHeaders["domain"]){
    requestHeaders.append('domain', moreHeaders["domain"]);
  } else{
    requestHeaders.append('domain', getPhishingAPIKey());
  }
  //console.log('Domain is', getDomain());
  return requestHeaders;
}
function requestHeaderMod(){
  console.log("Entered into requestHeader Modified");
  const requestHeaders = new Headers();
  requestHeaders.append('Accept', 'application/json');
  requestHeaders.append('Content-Type', 'application/json');
  //requestHeaders.append('authorization',`Bearer ${getPhishingAPIKey()}`)
  return requestHeaders;
}
function appendAPIKey(url, key) {
  return `${url}${url.includes('?') ? '&' : '?'}api_key=${encodeURIComponent(key || getPhishingAPIKey())}`;
}

// Keep shared catalog lookups in memory for one minute, scoped to the signed-in
// organization. Failed requests are never cached; switching accounts clears it.
let libraryScope;
let libraryRequests = new Map();
function libraryRequest(resource, load) {
  const scope = `${getDomain()}:${getPhishingAPIKey()}`;
  if (scope !== libraryScope) {
    libraryScope = scope;
    libraryRequests = new Map();
  }
  const cache = libraryRequests;
  const cached = cache.get(resource);
  if (cached && cached.expires > Date.now()) return cached.promise;
  const entry = {expires: Date.now() + 60000};
  entry.promise = Promise.resolve().then(load).catch(error => {
    if (cache.get(resource) === entry) cache.delete(resource);
    if (error.code === 401) cache.clear();
    throw error;
  });
  cache.set(resource, entry);
  return entry.promise;
}
function libraryKey() {
  return libraryRequest('key', () => fetchPhishingAPIKey('0.template'));
}
async function contentList(kind, headers) {
  if (headers?.domain === '0.template') {
    return libraryRequest(kind, async () => {
      const key = await libraryKey();
      return doGet(`${goPhishingURL}/${kind}/?summary=true`, key.apikey);
    });
  }
  const key = headers?.domain ? await fetchPhishingAPIKey(headers.domain) : null;
  return doGet(`${goPhishingURL}/${kind}/`, key?.apikey);
}
async function contentDetail(kind, id, headers) {
  const key = headers?.domain === '0.template' ? await libraryKey()
    : headers?.domain ? await fetchPhishingAPIKey(headers.domain) : null;
  return doGet(`${goPhishingURL}/${kind}/${id}`, key?.apikey);
}

function doGet(url, key) {
  url = appendAPIKey(url, key)
  let requestParams = {
    'method': 'GET',
    'dataType': 'json',
    headers: requestHeaderMod()
  };
  return trackPromise(
    fetchWithTimeout(url, requestParams).then(response => {
      return handleResponse(response);
    })
  );
}

function doGetBlob(url, moreHeader) {
  let requestParams = {
    method: 'GET',
    headers: requestHeaders(moreHeader)
  };
  return trackPromise(
    fetchWithTimeout(url, requestParams).then(response => {
      return handleResponse(response, true);
    })
  );
}

function doPost(url, data) {
  console.log("Entered into doPost" + data.url);
  url = appendAPIKey(url)
  return trackPromise(
    fetchWithTimeout(url, {
      method: 'POST',
      headers: requestHeaderMod(),
      body: JSON.stringify(data)
    }).then(response => {
      return handleResponse(response);
    })
  );
}
function doPut(url, data) {
  console.log("Entered into doPost" + data.url);
  return trackPromise(
    fetchWithTimeout(url, {
      method: 'PUT',
      headers: requestHeaders(),
      body: JSON.stringify(data)
    }).then(response => {
      return handleResponse(response);
    })
  );
}
function doDelete(url) {
  return trackPromise(
    fetchWithTimeout(url, {
      method: 'DELETE',
      headers: requestHeaders()
    }).then(response => {
      return handleResponse(response);
    })
  );
}


export function getwebsitecontent(url){
  return doPost(`${goPhishingURL}/import/site`,
    {
      "url": url
    });
}

export function getlandingpages(headers) {
  return contentList('pages', headers);
}
export function getLandingPage(id, headers) {
  return contentDetail('pages', id, headers);
}

export function createLandingPage(landingPage){
  var url = `${goPhishingURL}/pages/`;
  if(!landingPage.id){
    console.log('Entered into new landing page creation mode');
    delete landingPage.id;
    return doPost(url, landingPage)
  }
  console.log('Entered into edit landing page creation mode');
  //var id = landingPage.id;
  //var url = url+id;
  return doPut(`${servicesUrl}/phishing_v1/landingpage/create`, landingPage);
}

export function deleteLandingPage(id){
  return doDelete(`${servicesUrl}/phishing_v1/landingpage/delete?id=${id}`);
}

export function getEmailTemplateList(headers) {
  return contentList('templates', headers);
}
export function getEmailTemplate(id, headers) {
  return contentDetail('templates', id, headers);
}

export async function getSimulationTemplateList() {
  const [pages, messages] = await Promise.all([getlandingpages(), getEmailTemplateList()]);
  return simulationTemplates(pages, messages);
}

export function deleteSimulationTemplate(id) {
  return authenticatedDelete(`/phishing_v1/emailtemplate/simulation/${encodeURIComponent(id)}`, servicesUrl);
}

export function createEmailTemplate(emailTemplate){
  const emailTemplateClone = {...emailTemplate};
  var url = `${goPhishingURL}/templates/`;
  if(emailTemplateClone.modified_date){
    delete emailTemplateClone.modified_date;
  }
  if(!emailTemplateClone.id){
    delete emailTemplateClone.id;
    return doPost(url, emailTemplateClone);
  }
  url = `${servicesUrl}/phishing_v1/emailtemplate/create`;
  return doPut(url, emailTemplateClone);
}

export function deleteEmailTemplate(id){
  return doDelete(`${servicesUrl}/phishing_v1/emailtemplate/delete?id=${id}`);
}

export function importEmailTemplate(data){
  return doPost(`${goPhishingURL}/import/email`, data);
}

export function getGroupList(){
  return doGet(`${goPhishingURL}/groups/`);
}

export function createGroup(group){
  const groupClone = {...group};
  var url = `${goPhishingURL}/groups/`;
  if(group.modified_date){
    delete group.modified_date;
  }
  if(!group.id){
    delete group.id;
    return doPost(url, group);
  }
  return doPut(`${servicesUrl}/phishing_v1/usersandgroups/create`, group);
}

export function deleteGroup(group_id){
  return authenticatedDelete(`/phishing_v1/usersandgroups/simulation/${encodeURIComponent(group_id)}`, servicesUrl);
}

export async function getSMTPConfigList(){
  const profiles = await doGet(`${goPhishingURL}/smtp/`);
  if (!Array.isArray(profiles)) throw new Error('Invalid sending profiles');
  return profiles.map(({ id, name, from_address, modified_date, interface_type }) => ({ id, name, from_address, modified_date, interface_type }));
}

export function getDeliverySettings() {
  return authenticatedGet('/phishing_v1/smtpconfig/delivery-settings', servicesUrl);
}
export function getAuthenticatedDomains() { return authenticatedGet('/phishing_v1/authenticated-domains', servicesUrl); }
export function registerAuthenticatedDomain(domain) { return authenticatedPost('/phishing_v1/authenticated-domains', { domain }, servicesUrl); }
export function checkAuthenticatedDomain(id) { return authenticatedPost(`/phishing_v1/authenticated-domains/${encodeURIComponent(id)}/check`, {}, servicesUrl); }
export function deleteAuthenticatedDomain(id) { return authenticatedDelete(`/phishing_v1/authenticated-domains/${encodeURIComponent(id)}`, servicesUrl); }
export function checkDeliverySettings() {
  return authenticatedPost('/phishing_v1/smtpconfig/delivery-settings/check', {}, servicesUrl);
}

async function profileTransport(config) {
  if (!config.managed_profile) return config;
  // Keep local UI review compatible with the currently deployed API. The new
  // server independently resolves these internal values and ignores overrides.
  const connection = config.id ? await doGet(`${goPhishingURL}/smtp/${encodeURIComponent(config.id)}`) : await getDefaultSMTPConfig();
  return { ...connection, ...config };
}

export async function createSMTPConfig(smtpConfig) {
  const result = await doPut(`${servicesUrl}/phishing_v1/smtpconfig/create`, await profileTransport(smtpConfig));
  const { id, name, from_address, modified_date, interface_type } = result;
  return { id, name, from_address, modified_date, interface_type };
}

export function deleteSMTPConfig(smtpConfig_id){
  return authenticatedDelete(`/phishing_v1/smtpconfig/simulation/${encodeURIComponent(smtpConfig_id)}`, servicesUrl);
}

export function getDefaultSMTPConfig(){
  return doGet(`${servicesUrl}/phishing_v1/smtpconfig/default`);
}

export async function sendEmail(emailInfo){
  const smtp = await profileTransport(emailInfo.smtp);
  return trackPromise(fetchWithTimeout(`${servicesUrl}/phishing_v1/smtpconfig/send-test`, {
    method: 'POST',
    headers: requestHeaders(),
    body: JSON.stringify({ ...emailInfo, smtp })
  }).then(response => handleResponse(response)));
}

export function getCampaignList(){
  return doGet(`${goPhishingURL}/campaigns/summary`);
}

export function createPhishingCampaign(campaign){
  return doPut(`${servicesUrl}/phishing_v1/campaign/create`, { ...campaign });
}

export function fetchCampaignDetails(campaignId){
  return doGet(`${goPhishingURL}/campaigns/${campaignId}`)
}

export function deletePhishingCampaign(campaignId){
  return doDelete(`${servicesUrl}/phishing_v1/campaign/delete?campaignId=${campaignId}`)
} 
export function uploadFile(data){
  return trackPromise(
    fetchWithTimeout(`${servicesUrl}/phishing_v1/usersandgroups/upload`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: data
    }).then(response => {
      return handleResponse(response);
    })
  );
}

export function fetchCampaignSummary(campaignId) {
  return doGet(`${goPhishingURL}/campaigns/${campaignId}/summary`);
}

export function fetchCampaignTimelineDetails(campaignId){
  return doGet(`${goPhishingURL}/campaigns/${campaignId}/results`);
}

export function markCampaignAsComplete(campaignId){
  return doGet(`${goPhishingURL}/campaigns/${campaignId}/complete`);
}

export function downloadPhishingCampaignReport(campaignId){
  return doGetBlob(`${servicesUrl}/phishing_v1/campaign/getreport?campaignId=${campaignId}`);
}
export function fetchPhishingAPIKey(domain) {
  return authenticatedGet(`/phishing_v1/campaign/key?domain=${encodeURIComponent(domain)}`, servicesUrl);
}
